export const VideoURLs = {
  homepageVideo: "https://vimeo.com/1045497448/7c32482347",
  reviewVideo: "https://vimeo.com/991739365?",
  quotePageVideo: "https://vimeo.com/1058785235/2374ffd258"
}